export class FeaturesNotInReport {
  static readonly type = "[Reports] FeaturesNotInReport]";
}

export class GetAllBillStates {
  static readonly type = "[Reports] GetAllBillStates]";
}

export class GetBillsByStateAndPlace {
  static readonly type = "[Reports] GetBillsByStateAndPlace]";
  constructor(
    public readonly FK_BillState,
    public readonly StartDate_Bill,
    public readonly EndDate_Bill
  ) {}
}

export class UpdateMainInfo {
  static readonly type = "[Reports] UpdateMainInfo]";
  constructor(public readonly mainInfo) {}
}

export class ReportForProviders {
  static readonly type = "[Reports] ReportForProviders]";
}

export class BillsDeliveredReport {
  static readonly type = "[Reports] BillsDeliveredReport]";
  constructor(public readonly dateA, public readonly dateB) {}
}

export class Quotations {
  static readonly type = "[Reports] Quotations]";
}

export class CleanUsers {
  static readonly type = "[Reports] CleanUsers]";
}

export class RecentUsers {
  static readonly type = "[Reports] RecentUsers]";
  constructor(public readonly newQuery?: boolean) {}
}

export class AproveQuotation {
  static readonly type = "[Reports] AproveQuotation]";
  constructor(public readonly id: string) {}
}

export class SetCadesurFeatureFile {
  static readonly type = "[Reports] SetCadesurFeatureFile]";
  constructor(
    public readonly Route_File: string,
    public readonly FK_ProductFeature: string,
    public readonly FK_InventoryDetail: string,
    public readonly FirebaseId: String
  ) {}
}

export class RemoveCadesurFeatureFile {
  static readonly type = "[Reports] RemoveCadesurFeatureFile]";
  constructor(
    public readonly featureId: string,
    public readonly fileId: string
  ) {}
}

export class AddressByPerson {
  static readonly type = "[Reports] AddressByPerson]";
  constructor(public readonly id: string) {}
}

export class CleanAddress {
  static readonly type = "[Reports] CleanAddress]";
}

export class DownloadXML {
  static readonly type = "[Reports] DownloadXML]";
  constructor(public readonly id: string) {}
}

export class DownloadRespXML {
  static readonly type = "[Reports] DownloadRespXML]";
  constructor(public readonly id: string) {}
}

export class ElectronicBillByBill {
  static readonly type = "[Reports] ElectronicBillByBill]";
  constructor(public readonly id: string) {}
}

export class LoadProductList {
  static readonly type = "[Reports] LoadProductList]";
  constructor(public readonly list: any[]) {}
}

export class ProductFeatureByCadesurCode {
  static readonly type = "[Reports] ProductFeatureByCadesurCode]";
  constructor(public readonly CadesurCode_ProductFeature: string) {}
}

export class SetCadesurOffset {
  static readonly type = "[Reports] SetCadesurOffset]";
  constructor(public readonly offset: number) {}
}

export class CreateCadesurFeature {
  static readonly type = "[Reports] CreateCadesurFeature]";
  constructor(public readonly feature: any) {}
}

export class SyncCadesurFeature {
  static readonly type = "[Reports] SyncCadesurFeature]";
  constructor(public readonly feature: any) {}
}

export class ResendBillEmailTo {
  static readonly type = "[Reports] ResendBillEmailTo]";
  constructor(public readonly to: string, public readonly id: any) {}
}

export class SyncBarcodes {
  static readonly type = "[Reports] SyncBarcodes]";
  constructor(public readonly reset?: boolean) {}
}

export class SyncPrices {
  static readonly type = "[Reports] SyncPrices]";
  constructor(public readonly reset?: boolean) {}
}

export class ResendEB {
  static readonly type = "[Reports] ResendEB]";
  constructor(public readonly id: any) {}
}

export class RequestReceptionEB {
  static readonly type = "[Reports] RequestReceptionEB]";
  constructor(public readonly id: any) {}
}

export class SyncCabys {
  static readonly type = "[Reports] SyncCabys]";
  constructor(public readonly reset?: boolean) {}
}

export class SetCabys {
  static readonly type = "[Reports] SetCabys]";
  constructor(public readonly cadesurCabys?: any[]) {}
}

export class ProductFeaturesNoCabys {
  static readonly type = "[Reports] ProductFeaturesNoCabys]";
}

export class UpdateProductPriceOnly {
  static readonly type = "[Reports] UpdateProductPriceOnly]";
  constructor(public readonly newPrice: any) {}
}

export class TopFeatures {
  static readonly type = "[Reports] TopFeatures]";
  constructor(public readonly filters: any) {}
}

export class ToDeliverByDate {
  static readonly type = "[Reports] ToDeliverByDate]";
  constructor(public readonly dateA: Date, public readonly dateB: Date) {}
}

export class GetPlaceClients {
  static readonly type = "[Reports] GetPlaceClients";
  constructor(
    public readonly limit: number,
    public readonly offset: number,
    public readonly criteria?: string
  ) {}
}

export class GetBillStateMarket {
  static readonly type = "[Reports] GetBillStateMarket]";
}
